document.addEventListener("DOMContentLoaded", () => {
    const variantPicker = document.querySelector("variant-picker");
    if (!variantPicker) return;

    const variantData = JSON.parse(document.getElementById("variant-metafields-data").textContent,);

    const additionalMessage = document.querySelector("[data-additional-message]");
    const alertMessage = document.querySelector("[data-alert-message]");

    function updateVariantMessage(variantID) {
        if (!variantID) return;

        const data = variantData[variantID];
        if (!data) return;

        if (additionalMessage) {
            additionalMessage.innerHTML = data.preorder || "";
            additionalMessage.style.display = data.preorder ? "block" : "none";
        }

        if (alertMessage) {
            alertMessage.innerHTML = data.alertmessage || "";
            alertMessage.style.display = data.alertmessage ? "block" : "none";
        }
    }

    updateVariantMessage();

    variantPicker.addEventListener("variant:update", (event) => {
        updateVariantMessage(event.detail.resource.id);
    });
});
